import script from "./VideoPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./VideoPlayer.vue?vue&type=style&index=0&id=51078aa2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51078aa2"]])

export default __exports__